import { TEXT_TAGS, TextTag, iconMapping } from "../../../models/CardAbility"
import { SidewaysCrystal } from "../../Crystal/SidewaysCrystal"

export type AbilityTextSymbolButtonContentProps = {
    label: string,
    data: TextTag | undefined
}

export function AbilityTextSymbolButtonContent(props: AbilityTextSymbolButtonContentProps) {
    if (!props.data) {
        return <span key={props.label}>{props.label}</span>
    }

    const trimmedSymbol = props.data.replace("{", "").replace("}", "");
    const iconMatch = iconMapping[trimmedSymbol];

    if (iconMatch) {
        return <span key={iconMatch} className={"ff-icon " + iconMatch}><span className="sr-only">{props.label}</span></span>
    }

    if (props.data === TEXT_TAGS.crystalIcon) {
        return <SidewaysCrystal className="h-3 w-3 inline-block" />
    }

    return (
        <svg key={trimmedSymbol} version="1.1" xmlns="http://www.w3.org/2000/svg" className="inline-block" height="15px" width="15px" x="0px" y="0px" viewBox="0 0 32 32">
            <circle className="circle" cx="16" cy="16" r="15" />
            <text transform="matrix(1 0 0 1 8.9355 24.875)" className="circle-text">{trimmedSymbol}</text>
        </svg>
    )
}